module.exports = __webpack_public_path__ + "static/media/flyermechanicFaico.579ff9b2.png";